import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useRef } from "react";

import { IoIosInformationCircleOutline } from "react-icons/io";


import { useInduction } from "../../hooks/useInduction";
import { Button } from '../Button';
import { Address, IFormInput, InductionFieldsConfiuration, InductionQuestionConfiguration, InductionQuizConfiguration, QuestionsResponse, QuizInduction } from "../../TypesOrInterfaces/induction";
import { HTMLElement } from "../../util/parseTo"
import { idPlanoCristalia, idPlanoUniaoQuimica, idPlanoMinhaDII } from '../../../src/config';

import {
    ALPHATEXT_PATTERN
    , CEP_PATTERN
    , CPF_PATTERN
    , EMAIL_PATTERN
    , TELEFONE_PATTERN
} from "../../util/pattern";

import {
    Container
    , ContainerOptionSendAcceptanceTerm
    , ContainerOptionsRadio
    , ContainerReceiveAccess
    , ContainerContactTypes
    , Form
    , Navigation
    , AlertInfo
} from "./styles";
import { FAZ_BEM_ID, NESTLE_ID, addressCaregiver, caregiverApiAlias, caregiverApiAliasHidden, checkBoxesBeneficiaryHidden, checkBoxesCaregiverHidden, fieldsCaregiverNotRequired, quizCaregiverHidden } from "../../util/aliasHidden";
import Input from "../Form/Input";
import { useQuiz } from "../../hooks/useQuiz";
import { useAstrazeneca } from "../../hooks/useAstrazeneca";
import {
    getMovedQuizQuestionPriority,
    hasQuizQuestionsOutsideBeneficiaryForm,
    prescriberCrmAliases,
    prescriberNameAliases,
    prescriberStateAliases
} from "../../util/quizForm";

export function FormDynamic() {
    const { configuration
        , beneficiaryRegister
        , beneficiaryBirthDate
        , haveRegistration
        , setBeneficiary
        , cardHolderNumber
        , beneficiaryInfo
        , getAddressZipCode
        , setValueDisplayQuizzes
        , setValueDisplayForm
        , setValueDisplaySearch
        , address
        , addFields
        , fields
        , resetAll
        , benefitName
        , questionResponsibleName
        , questionResponsibleBirthDate
        , questionResponsibleDegreeKinship
        , questionResponsibleAcceptance
        , setQuestionResponsibleAcceptance
        , questionResponsibleDocument
        , isActiveLoader
        , setOptionSendAcceptanceTerm
        , contact0
        , contact1
        , contact2
        , contact3
        , setContact0
        , setContact1
        , setContact2
        , setContact3
        , resetBeneficiary
        , fieldsCaregiver
        , setFieldsCaregiver
        , setCaregiverData
        , addQuiz
        , beneficiaryHasCaregiver
        , setBeneficiaryHasCaregiver
        , plainHasCaregiver
        , setPlainHasCaregiver
        , checkBoxesCaregiven
        , setCheckBoxesCaregiven
        , lastCaregivenData
        , setLastCaregivenData
        , fieldsCaregiverData
        , setFieldsCaregiverData
        , benefitId
        , isUpdate
        , getPrescriber
        , prescriber
        , resetPrescriber
    } = useInduction();


    const { updateQuizzes } = useQuiz();

    const [hasAwnserTerm, setHasAwnserTerm] = useState<boolean | undefined>()

    const { termBeneficiary } = useAstrazeneca(configuration, benefitId)

    const { register, handleSubmit, errors, setValue, getValues, clearErrors } = useForm();
    const formRef = useRef<HTMLFormElement | null>(null);


    const [sameAddress, setSameAddress] = useState<boolean>(false)
    const [isFormReadyToSubmit, setIsFormReadyToSubmit] = useState(false);
    const [stateCod, setStateCode] = useState('');
    const [prescriberCrm, setPrescriberCrm] = useState('');

    const [isMinor, setIsMinor] = useState(() => {
        const result = localStorage.getItem('@EpharmaInductionIsMinor');


        if (result) {
            return Boolean(result);
        }
        return false;
    });

    const [birthday, setBirthday] = useState(beneficiaryBirthDate);
    const [responsibleAcceptance, setResponsibleAcceptance] = useState<boolean>(questionResponsibleAcceptance);

    const beneficiary = fields.length === 0 ? beneficiaryRegister.fields : fields;

    const hasQuizzes = configuration.quiz?.length > 0;

    const otherIssuesBeyondTheTerm = hasQuizQuestionsOutsideBeneficiaryForm(configuration, benefitId);

    const receiveAccess = configuration.quiz?.filter(f => f.questions?.map(
        question => question.questionAlias.toLowerCase() === 'question_receive_access'
    ))[0]?.questions.filter(question => question.questionAlias.toLowerCase() === 'question_receive_access')[0];

    const questionAcceptContactTypesValues = configuration.quiz?.filter(f => f.questions?.map(
        question => question.questionAlias.toLowerCase() === 'question_accept_contact_types'
    ))[0]?.questions.filter(question => question.questionAlias.toLowerCase() === 'question_accept_contact_types');

    const apiAliasHidden = ["beneficiario_dt_fim"
        , "beneficiario_data_alteracao"
        , "beneficiario_dt_inicio"
        , "beneficiario_cartao_usuario"
        , "beneficiario_cartao_titular"
    ];

    const responsibleLegalQuestions = [
        'question_responsible_document',
        'question_responsible_name',
        'question_responsible_birth_date',
        'question_responsible_degree_of_kinship',
        'question_responsible_acceptance'
    ];

    const isNestleTermBeneficiaryQuiz = benefitId === NESTLE_ID
        && termBeneficiary?.name?.toLowerCase().replaceAll(" ", "") === "nestlequiz";

    const beneficiaryHiddenTermQuestions = isNestleTermBeneficiaryQuiz
        ? ['question_late-term_acceptance', ...responsibleLegalQuestions]
        : checkBoxesBeneficiaryHidden;

    let defaultCpf = "";

    if (beneficiaryInfo?.cpf)
        defaultCpf = beneficiaryInfo.cpf;
    else if (cardHolderNumber)
        defaultCpf = cardHolderNumber;

    const termBeneficiaryResponse = beneficiaryRegister?.quiz?.find(
        quiz => quiz.id === termBeneficiary?.id || quiz.configurationId === termBeneficiary?.configurationId
    );

    const hasRequiredFieldsLegend = configuration.fields?.some(field =>
        !apiAliasHidden.includes(field?.apiAlias) && (field.isRequiredOnCreate || field.isRequiredOnUpdate)
    ) || termBeneficiary?.questions?.some(question =>
        !beneficiaryHiddenTermQuestions.includes(question.questionAlias.toLowerCase()) && question.isRequired
    ) || !!receiveAccess;

    function isVisibleFormControl(element: HTMLElement) {
        return !element.hidden && !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    function shouldIgnoreFormControl(element: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement) {
        return element.disabled
            || !isVisibleFormControl(element)
            || (element instanceof HTMLInputElement && element.type === 'hidden');
    }

    function isRequiredFormControlFilled(
        element: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement,
        form: HTMLFormElement
    ) {
        if (shouldIgnoreFormControl(element)) {
            return true;
        }

        if (element instanceof HTMLInputElement && element.type === 'radio') {
            return Array.from(form.elements).some(formElement =>
                formElement instanceof HTMLInputElement
                && formElement.name === element.name
                && formElement.checked
            );
        }

        if (element instanceof HTMLInputElement && element.type === 'checkbox') {
            return element.checked;
        }

        return String(element.value || '').trim().length > 0;
    }

    function validateVisibleFormControls(form: HTMLFormElement) {
        return Array.from(form.elements).every(formElement => {
            if (
                !(formElement instanceof HTMLInputElement)
                && !(formElement instanceof HTMLSelectElement)
                && !(formElement instanceof HTMLTextAreaElement)
            ) {
                return true;
            }

            if (shouldIgnoreFormControl(formElement)) {
                return true;
            }

            return formElement.checkValidity();
        });
    }

    function updateSubmitButtonState() {
        const form = formRef.current;

        if (!form) {
            setIsFormReadyToSubmit(false);
            return;
        }

        const requiredControls = Array.from(
            form.querySelectorAll('input[required], select[required], textarea[required]')
        ) as Array<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>;

        const requiredControlsFilled = requiredControls.every(element =>
            isRequiredFormControlFilled(element, form)
        );

        setIsFormReadyToSubmit(requiredControlsFilled && validateVisibleFormControls(form));
    }

    function scheduleSubmitButtonStateUpdate() {
        window.setTimeout(updateSubmitButtonState, 0);
    }

    function normalizeRequiredLabel(label: string) {
        return String(label || '').replace(/\s*\*+\s*/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function requiredFieldMessage(label: string) {
        return `${normalizeRequiredLabel(label)} obrigatório`;
    }

    function renderRequiredLabel(label: string, isRequired?: boolean) {
        return (
            <>
                {normalizeRequiredLabel(label)}
                {isRequired && <span className="required-indicator" aria-hidden="true">*</span>}
            </>
        );
    }

    function getQuizQuestionDefaultValue(question: InductionQuestionConfiguration) {
        const beneficiaryQuizValue = termBeneficiaryResponse?.questions?.find(answer => answer.id === question.id)?.value;

        if (beneficiaryQuizValue !== undefined && beneficiaryQuizValue !== null && beneficiaryQuizValue !== '') {
            return beneficiaryQuizValue;
        }

        return lastCaregivenData?.quizz?.find(
            (dataField: { questionAlias: string; }) => dataField.questionAlias.toLocaleLowerCase() === question.questionAlias.toLocaleLowerCase()
        )?.value || '';
    }

    const handleChangeSendTerm = (value: string) => {
        setOptionSendAcceptanceTerm(Number(value));
    }

    const checkQuestionResponsible = (value: boolean) => {
        setResponsibleAcceptance(value);
        setQuestionResponsibleAcceptance(value);
    }

    function getQuestionFieldName(question: InductionQuestionConfiguration) {
        return String(question.questionAlias.toLowerCase());
    }

    function handleSelectPrescriberState(value: string) {
        setStateCode(value);
    }

    function handleSetPrescriberCrm(value: string) {
        setPrescriberCrm(value.replace(/\D/g, ''));
    }

    function renderListQuestionOnForm(question: InductionQuestionConfiguration, defaultValue: string = '') {
        const fieldName = getQuestionFieldName(question);

        return (
            <div className="control" key={fieldName}>
                <label htmlFor={fieldName}>
                    {renderRequiredLabel(question.title, question.isRequired)}
                </label>
                <select
                    id={fieldName}
                    name={fieldName}
                    defaultValue={defaultValue}
                    required={question.isRequired}
                    ref={register({
                        required: {
                            value: question.isRequired,
                            message: requiredFieldMessage(question.title)
                        }
                    })}
                >
                    <option value=''></option>
                    {question.allowedValues?.map(allowedValue => (
                        <option key={allowedValue.value} value={allowedValue.value}>
                            {allowedValue.label}
                        </option>
                    ))}
                </select>
                {errors[fieldName] && <span className="input-error-message">{errors[fieldName].message}</span>}
            </div>
        )
    }

    function renderTermBeneficiaryQuestion(question: InductionQuestionConfiguration) {
        const questionAlias = question.questionAlias.toLowerCase();
        const fieldName = getQuestionFieldName(question);
        const defaultValue = getQuizQuestionDefaultValue(question);
        const prescriberMatchesCurrentSearch = !!stateCod
            && !!prescriberCrm
            && prescriber?.clientSystemSg === stateCod
            && prescriber?.clientSystemNumber === prescriberCrm;

        if (prescriberStateAliases.includes(questionAlias)) {
            return (
                <div className="control" key={fieldName}>
                    <label htmlFor={fieldName}>
                        {renderRequiredLabel(question.title, question.isRequired)}
                    </label>
                    <select
                        id={fieldName}
                        name={fieldName}
                        defaultValue={defaultValue}
                        onChange={event => handleSelectPrescriberState(event.target.value)}
                        required={question.isRequired}
                        ref={register({
                            required: {
                                value: question.isRequired,
                                message: requiredFieldMessage(question.title)
                            }
                        })}
                    >
                        <option value=''></option>
                        {question.allowedValues?.map(allowedValue => (
                            <option key={allowedValue.value} value={allowedValue.value}>
                                {allowedValue.label}
                            </option>
                        ))}
                    </select>
                    {errors[fieldName] && <span className="input-error-message">{errors[fieldName].message}</span>}
                </div>
            )
        }

        if (prescriberCrmAliases.includes(questionAlias)) {
            return (
                <div className="control" key={fieldName}>
                    <label htmlFor={fieldName}>
                        {renderRequiredLabel(`${normalizeRequiredLabel(question.title)} (Para médicos do RJ, não inserir o prefixo 52)`, question.isRequired)}
                    </label>
                    <Input
                        register={register}
                        errors={errors}
                        type="text"
                        key={fieldName}
                        name={fieldName}
                        defaultValue={defaultValue}
                        placeholder={normalizeRequiredLabel(question.title)}
                        maxLength={question.maximumAnswerLength}
                        errorMessage={requiredFieldMessage(question.title)}
                        min={1}
                        required={question.isRequired}
                        onChange={(event: any) => handleSetPrescriberCrm(event.target.value)}
                    />
                </div>
            )
        }

        if (prescriberNameAliases.includes(questionAlias)) {
            const prescriberName = prescriberMatchesCurrentSearch ? prescriber?.name : '';

            return (
                <div className="control" key={fieldName}>
                    <label htmlFor={fieldName}>
                        {renderRequiredLabel(question.title, question.isRequired)}
                    </label>
                    <input
                        id={fieldName}
                        type="text"
                        name={fieldName}
                        placeholder={normalizeRequiredLabel(question.title)}
                        value={prescriberName}
                        required={question.isRequired}
                        ref={register({
                            required: {
                                value: question.isRequired,
                                message: requiredFieldMessage(question.title)
                            }
                        })}
                        readOnly
                    />
                    {errors[fieldName] && <span className="input-error-message">{errors[fieldName].message}</span>}
                </div>
            )
        }

        if (question.questionType.toLowerCase() === 'lista') {
            return renderListQuestionOnForm(question, defaultValue);
        }

        return HTMLElement(
            question,
            register({
                required: {
                    value: question.isRequired,
                    message: requiredFieldMessage(question.title)
                }
            }),
            defaultValue,
            errors,
            register
        )
    }

    async function handleSubmitForm(data: IFormInput) {
        data = getValues()
        const result = await addFields(data);

        let awanserQuiz = termBeneficiary?.questions?.reduce((obj, x) => {

            return {
                ...obj,
                [x.id]: data[x.questionAlias.toLowerCase()]
            }
        }, {}) || {}

        if (!!termBeneficiary?.id && !hasAwnserTerm) {

            addQuiz(awanserQuiz as IFormInput, termBeneficiary)

        }
        if (beneficiaryHasCaregiver) {

            const caregiverData = {
                question_caregiver_areacodecellphone: data.question_caregiver_cellphone.slice(1, 3),
                question_caregiver_areacodephone: data?.question_caregiver_phone.slice(1, 3),
                question_caregiver_cellphone: '',
                question_caregiver_phone: '',
            };

            Object.getOwnPropertyNames(data).filter(x => caregiverApiAlias.includes(x.toLocaleLowerCase())).forEach(x => {
                /// if temporario, pois Question_Caregiver_EmailOptIn está Duplicado (aceite de termo e contato por email )
                if (Array.isArray(data[x])) {
                    (caregiverData as any)[x] = !!data[x][0]
                } else {
                    (caregiverData as any)[x] = data[x]
                }

            })

            caregiverData.question_caregiver_cellphone = caregiverData.question_caregiver_cellphone.slice(5)
            caregiverData.question_caregiver_phone = caregiverData?.question_caregiver_phone.slice(5)

            setCaregiverData(caregiverData)
        }

        if (!hasQuizzes || (hasQuizzes && !otherIssuesBeyondTheTerm)) {
            setBeneficiary(result, Number(data['optionSendAcceptanceTerm']));
        }
        else {
            setValueDisplayForm(false);
            setValueDisplayQuizzes(true);
        }

        if (benefitId === FAZ_BEM_ID && isUpdate && hasAwnserTerm) {

            await updateQuizzes(awanserQuiz, termBeneficiary.id)
        }

    }

    function goBackSearch() {
        setValueDisplaySearch(true);
        setValueDisplayForm(false);
        resetBeneficiary();
    }


    function handleSameAddress() {
        setSameAddress(true)

        const fields = getValues()
        const UF = fields[16].slice(-2)

        setValue('question_caregiver_zipcode', fields[18]);//18 // cep
        setValue('question_caregiver_city', fields[16]);//16 //cidad
        setValue('question_caregiver_address', fields[12]);//12 // logradouro
        setValue('question_caregiver_number', fields[13]);//13 // numer
        setValue('question_caregiver_district', fields[15]);//15 // bairro
        setValue('question_caregiver_addresscomplement', fields[14]);//14 // complemento
        setValue('question_caregiver_state', UF); // UF     

        const caregiver = {
            ...fieldsCaregiverData, 'question_caregiver_state': UF
            , 'question_caregiver_zipcode': fields[18]
            , 'question_caregiver_city': fields[16]
            , 'question_caregiver_address': fields[12]
            , 'question_caregiver_number': fields[13]
            , 'question_caregiver_district': fields[15]
            , 'question_caregiver_addresscomplement': fields[14]
        }

        setFieldsCaregiverData(caregiver)
        setCaregiverData(caregiver)

    }

    async function handleGetCaregiverAddress(cep: string) {
        if (cep.replace(/\D/g, '').length !== 8){
            return;
        }

        const result = await getAddressZipCode(cep.replace(/\D/g, ''));

        if (result) {
            
            setValue('question_caregiver_state',  result?.city?.state?.stateCode || "");
            setValue('question_caregiver_city', result?.city?.name);
            setValue('question_caregiver_address', result?.addressLine);
            setValue('question_caregiver_district', result?.neighborhood);
        }
    }

    async function handleGetAddress(value: string) {
        if (value.replace(/\D/g, '').length !== 8)
            return;

        const result = await getAddressZipCode(value.replace(/\D/g, ''));

        if (result) {
            refreshAddress(result);
        }
    }

    function fieldOrdering(a: InductionFieldsConfiuration, b: InductionFieldsConfiuration) {
        if (a.order > b.order)
            return 1;
        else if (a.order < b.order) return -1;
        return 0;
    }

    function questionOrdering(a: InductionQuestionConfiguration, b: InductionQuestionConfiguration) {
        if (a.order > b.order)
            return 1;
        else if (a.order < b.order) return -1;
        return 0;
    }

    function termBeneficiaryQuestionOrdering(a: InductionQuestionConfiguration, b: InductionQuestionConfiguration) {
        const priority = getMovedQuizQuestionPriority(benefitId);
        const aPriority = priority.indexOf(a.questionAlias.toLowerCase());
        const bPriority = priority.indexOf(b.questionAlias.toLowerCase());

        if (aPriority !== -1 || bPriority !== -1) {
            if (aPriority === -1) return 1;
            if (bPriority === -1) return -1;
            return aPriority - bPriority;
        }

        return questionOrdering(a, b);
    }

    function formatDateYYYYMMDD(value: string) {
        if (!value)
            return;

        if (value.indexOf('-') >= 0) {
            const array = value.split(/\s/)[0].split('-');
            value = array[2] + "/" + array[1] + "/" + array[0]
        }

        const arrayDate = value.split(/\s/)[0].split('/');

        var data = new Intl.DateTimeFormat('fr-ca')
            .format(new Date(Number(arrayDate[2]), Number(arrayDate[1]) - 1, Number(arrayDate[0])));

        return data;
    }

    function refreshAddress(value: Address) {
        setValue('12', value?.addressLine);
        setValue('15', value?.neighborhood);

        clearErrors('12');
        clearErrors('15');

        if (value?.city?.name) {
            setValue('16', (value?.city?.name || "") + "/" + (value?.city?.state?.stateCode || ""));
            clearErrors('16');

        }
        setValue('17', value?.city?.state?.stateCode);
        clearErrors('17');


        if (!!value?.city?.name && !!beneficiary?.filter(f => f.columnId === 16)[0]?.value) {
            setValue('13', '');
            clearErrors('13');

        }

        if (sameAddress) {
            handleSameAddress()
        }

    }

    function setCheckedContactType(index: number, val: boolean) {
        switch (index) {
            case 0:
                setContact0(val);
                // set_Contact0(val);
                break
            case 1:
                setContact1(val);
                // set_Contact1(val);
                break
            case 2:
                setContact2(val);
                // set_Contact2(val);
                break
            case 3:
                setContact3(val);
                // set_Contact3(val);
                break
        }
    }

    function getContactMask(api_alias:string){
        if(benefitId === FAZ_BEM_ID){
            return api_alias.includes("cel") ? "(99) 9 9999-9999" : "(99) 9999-9999"
        }
    }

    useEffect(() => {
        function verifyMandatoryResponsibility() {
            if (!birthday) {
                let idBirth = configuration?.fields?.filter(field =>
                    field?.apiAlias?.toLowerCase() === 'beneficiario_dt_nascimento')[0]?.columnId;

                setBirthday(beneficiaryRegister?.fields?.find(x => x.columnId == idBirth)?.value || "");
            }

            if (birthday) {
                let birth = "";

                if (birthday.indexOf('/') > -1) {
                    const arrDate = birthday.split('/');
                    birth = arrDate[2] + "-" + arrDate[0] + "-" + arrDate[1]
                }

                let value = (birth ? birth : birthday)?.split('-').map(m => Number(m));

                const result = Math.floor(
                    Math.ceil(Math.abs(
                        new Date(`${value[0]}-${value[1]}-${value[2] + 1}`).getTime() - new Date().getTime()
                    ) / (1000 * 3600 * 24)) / 365.25) < 18 ? true : false;



                if (result && (benefitId === idPlanoCristalia || benefitId === idPlanoUniaoQuimica || benefitId === idPlanoMinhaDII)) {
                    setIsMinor(result);
                } else {
                    setIsMinor(false);
                }

                localStorage.setItem('@EpharmaInductionIsMinor', String(result));
                setBeneficiaryHasCaregiver((result || beneficiaryHasCaregiver) && plainHasCaregiver)
                return;
            }

            setIsMinor(false);
        }

        verifyMandatoryResponsibility();
    }, [birthday]);

    useEffect(() => {
        setResponsibleAcceptance(questionResponsibleAcceptance);
    }, [questionResponsibleAcceptance]);

    useEffect(() => {

        var medicamentosHasCaregiver = configuration.quiz?.filter(x => x.questions.filter(x => caregiverApiAlias.includes(x.questionAlias.toLocaleLowerCase())).length > 0) || []

        if (!!beneficiaryRegister?.fields?.length) {
            var medicamentosHasCaregiverAwnser = beneficiaryRegister?.quiz?.map(beneficiaryQuizz => {

                let quizz = medicamentosHasCaregiver.find(e => e.id == beneficiaryQuizz.id)
                if (!quizz) {
                    return;
                }

                let quizzAnwser = quizz?.questions.map(configQuizz => {
                    return {
                        ...configQuizz,
                        value: beneficiaryQuizz.questions.find(e => e.id == configQuizz.id)?.value
                    }
                })

                return {
                    id: quizz?.id,
                    medicamento: quizz?.name,
                    createdAt: (beneficiaryQuizz as any).createdAt,
                    quizz: quizzAnwser
                };

            }).filter(x => !!x)

            var last = medicamentosHasCaregiverAwnser?.sort((a, b) => new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime())[0]
            setLastCaregivenData(last)

            setBeneficiaryHasCaregiver(!!last?.quizz.find(x => x.questionAlias.toLowerCase() === "question_caregiver_cpf")?.value)



        }
        setPlainHasCaregiver(fieldsCaregiver.length > 0)
        setCheckBoxesCaregiven(fieldsCaregiver.filter(x => x.questionType.toLocaleLowerCase() === 'checkbox'))


    }, [])

    useEffect(() => {
        const hasAnsweredTerm = termBeneficiaryResponse?.questions?.some(question => {
            return question.value !== undefined && question.value !== null && `${question.value}` !== '';
        }) || false;

        setHasAwnserTerm(hasAnsweredTerm);
    }, [termBeneficiaryResponse]);

    useEffect(() => {
        const stateQuestion = termBeneficiary?.questions?.find(
            question => prescriberStateAliases.includes(question.questionAlias.toLowerCase())
        );
        const crmQuestion = termBeneficiary?.questions?.find(
            question => prescriberCrmAliases.includes(question.questionAlias.toLowerCase())
        );

        const stateValue = stateQuestion ? getQuizQuestionDefaultValue(stateQuestion) : '';
        const crmValue = crmQuestion ? getQuizQuestionDefaultValue(crmQuestion).replace(/\D/g, '') : '';

        if (stateValue && !stateCod) {
            setStateCode(stateValue);
        }

        if (crmValue && !prescriberCrm) {
            setPrescriberCrm(crmValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [termBeneficiary?.id, termBeneficiaryResponse]);

    useEffect(() => {
        async function handleGetPrescriber() {
            if (stateCod && prescriberCrm) {
                await getPrescriber(stateCod, prescriberCrm);
                return;
            }

            await resetPrescriber();
        }

        handleGetPrescriber();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateCod, prescriberCrm]);

    useEffect(() => {
        const nameQuestion = termBeneficiary?.questions?.find(
            question => prescriberNameAliases.includes(question.questionAlias.toLowerCase())
        );

        if (!nameQuestion) {
            return;
        }

        const prescriberMatchesCurrentSearch = !!stateCod
            && !!prescriberCrm
            && prescriber?.clientSystemSg === stateCod
            && prescriber?.clientSystemNumber === prescriberCrm;

        setValue(getQuestionFieldName(nameQuestion), prescriberMatchesCurrentSearch ? prescriber?.name : '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prescriber, stateCod, prescriberCrm, termBeneficiary?.id, termBeneficiaryResponse]);

    useEffect(() => {
        const timeout = window.setTimeout(updateSubmitButtonState, 0);

        return () => window.clearTimeout(timeout);
    });

    const isSubmitButtonDisabled = isActiveLoader || !isFormReadyToSubmit;

    function verifyResponsibleBirthDate(birthday: string) {

        if (birthday) {
            let birth = "";

            if (birthday.indexOf('/') > -1) {
                const arrDate = birthday.split('/');
                birth = arrDate[2] + "-" + arrDate[0] + "-" + arrDate[1]
            }

            let value = (birth ? birth : birthday)?.split('-').map(m => Number(m));

            const result = Math.floor(
                Math.ceil(Math.abs(
                    new Date(`${value[0]}-${value[1]}-${value[2] + 1}`).getTime() - new Date().getTime()
                ) / (1000 * 3600 * 24)) / 365.25) < 18 ? true : false;

            return result;
        }
    }

    if (!configuration.fields || !configuration.quiz) {
        return null;
    }

    return (
        <Container>
            <h1>Dados do Beneficiário - <span>{benefitName}</span></h1>
            <br />
            <AlertInfo variant={"warning"}>

                <div className="control">

                    <IoIosInformationCircleOutline size={50} color="#F5AF45" fill="#F5AF45" />

                    <p>

                        <strong>Atenção!</strong> É fundamental assegurar que o beneficiário esteja ciente que está sendo cadastrado no programa {benefitName}, bem como garantir a veracidade das informações fornecidas.

                    </p>

                </div>

            </AlertInfo>
            <Form
                ref={formRef}
                className="form-dynamic"
                onSubmit={handleSubmit(handleSubmitForm)}
                onChange={scheduleSubmitButtonStateUpdate}
                onInput={scheduleSubmitButtonStateUpdate}
            >
                {hasRequiredFieldsLegend && (
                    <p className="required-fields-legend">
                        <span className="required-indicator" aria-hidden="true">*</span>
                        Campo obrigatório
                    </p>
                )}
                <div className="form-fields">
                    {
                        configuration.fields?.sort(fieldOrdering).map(field => {

                            if (!apiAliasHidden.includes(field?.apiAlias)) {
                                switch (field.type.toLowerCase()) {
                                    case 'cep':
                                        return (
                                            <div className="control">
                                                <label htmlFor={String(field.apiAlias)}>
                                                    {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                </label>
                                                <Input
                                                    register={register}
                                                    errors={errors}
                                                    mask="99999-999"
                                                    type="text"
                                                    placeholder={field.label}
                                                    name={String(field.columnId)}
                                                    defaultValue={beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value || ''}
                                                    errorMessage={`${field.label} obrigatório`}
                                                    min={1}
                                                    required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                    onChange={(event: any) => handleGetAddress(event.target.value)}
                                                    key={field.columnId}
                                                />
                                            </div>
                                        )



                                    case 'check':
                                        break;
                                    case 'cpf':
                                        return (
                                            <div className="control">
                                                <label htmlFor={String(field.apiAlias)}>
                                                    {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                </label>

                                                <Input
                                                    register={register}
                                                    errors={errors}
                                                    mask="999.999.999-99"
                                                    type="text"
                                                    placeholder={field.label}
                                                    name={String(field.columnId)}
                                                    defaultValue={defaultCpf}
                                                    errorMessage={`${field.label} obrigatório`}
                                                    required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                    disabled
                                                    key={field.columnId}
                                                />
                                            </div>
                                        )

                                    case 'data':

                                        if (field.apiAlias?.toLowerCase() === 'beneficiario_dt_nascimento') {
                                            return (
                                                <div className="control">
                                                    <label htmlFor={String(field.apiAlias)}>
                                                        {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                    </label>

                                                    <Input
                                                        register={register}
                                                        errors={errors}
                                                        type="date"
                                                        placeholder={field.label}
                                                        name={String(field.columnId)}
                                                        // value={formatDateYYYYMMDD(birthday || (beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value))}
                                                        value={(birthday || (beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value))}
                                                        errorMessage={`${field.label} obrigatório`}
                                                        required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                        onBlur={(event: any) => setBirthday(event.target.value)}
                                                        // defaultValue={formatDateYYYYMMDD(birthday || (beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value))}
                                                        defaultValue={(birthday || (beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value))}
                                                        max={new Intl.DateTimeFormat('fr-ca').format(new Date())}
                                                        min={new Intl.DateTimeFormat('fr-ca').format(new Date(1900, 0, 1))}
                                                        key={field.columnId}
                                                        disabled={(birthday)}
                                                    />
                                                </div>);
                                        }

                                        return (
                                            <div className="control">
                                                <label htmlFor={String(field.apiAlias)}>
                                                    {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                </label>

                                                <Input
                                                    register={register}
                                                    errors={errors}
                                                    type="date"
                                                    placeholder={field.label}
                                                    name={String(field.columnId)}
                                                    value={formatDateYYYYMMDD(beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value)}
                                                    errorMessage={`${field.label} obrigatório`}
                                                    required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                    onChange={(event: any) => setBirthday(event.target.value)}
                                                    defaultValue={formatDateYYYYMMDD(birthday || (beneficiary?.filter(f => f.columnId === field.columnId
                                                    )[0]?.value))}
                                                    max={new Intl.DateTimeFormat('fr-ca').format(new Date())}
                                                    min={new Intl.DateTimeFormat('fr-ca').format(new Date(1900, 0, 1))}
                                                    key={field.columnId}
                                                />
                                            </div>);
                                    case 'decimal':
                                        break;
                                    case 'inteiro':
                                        if (field.apiAlias?.toLowerCase() === 'beneficiario_endereco_numero')
                                            return (
                                                <div className="control">
                                                    <label htmlFor={String(field.apiAlias)}>
                                                        {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                    </label>
                                                    <Input
                                                        register={register}
                                                        errors={errors}
                                                        type="number"
                                                        placeholder={field.label}
                                                        name={String(field.columnId)}
                                                        value={beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value || cardHolderNumber}
                                                        errorMessage={`${field.label} obrigatório`}
                                                        required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                        key={field.columnId}
                                                    />
                                                </div>
                                            )
                                        break;
                                    case 'lista select':
                                    case 'lista valores fixos':

                                        if (field.apiAlias?.toLowerCase() === 'beneficiario_endereco_uf') {
                                            return (
                                                <select
                                                    key={field.columnId}
                                                    name={String(field.columnId)}
                                                    hidden
                                                    required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                    ref={register({
                                                        required: {
                                                            value: field.isRequiredOnCreate || field.isRequiredOnUpdate,
                                                            message: `${field.label} obrigatório`
                                                        }
                                                    })}
                                                    defaultValue={address?.city?.state?.stateCode || beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value}
                                                >
                                                    {field.allowedValues?.map(allowedValue => (
                                                        <option key={allowedValue.value} value={allowedValue.value}>{allowedValue.label}</option>
                                                    ))}
                                                </select>
                                            )
                                        }

                                        return (
                                            <div className="control">
                                                <label htmlFor={String(field.apiAlias)}>
                                                    {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                </label>
                                                <select
                                                    key={field.columnId}
                                                    name={String(field.columnId)}
                                                    defaultValue={beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value}
                                                    required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                    ref={register({
                                                        required: {
                                                            value: field.isRequiredOnCreate || field.isRequiredOnUpdate,
                                                            message: `${field.label} obrigatório`
                                                        }
                                                    })}
                                                >
                                                    {field.allowedValues?.map(allowedValue => (
                                                        <option key={allowedValue.value} value={allowedValue.value}>{allowedValue.label}</option>
                                                    ))}
                                                </select>
                                            </div>);

                                    case 'telefone':
                                        return (
                                            <div className="control">
                                                <label htmlFor={String(field.apiAlias)}>
                                                    {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                </label>

                                                <Input
                                                    register={register}
                                                    errors={errors}
                                                    mask= {getContactMask(field.apiAlias)}
                                                    type="text"
                                                    placeholder={field.label}
                                                    name={String(field.columnId)}
                                                    defaultValue={beneficiary?.find(f => f.columnId === field.columnId)?.value ?? beneficiaryInfo?.celular}
                                                    errorMessage={`${field.label} obrigatório`}
                                                    required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                    key={field.columnId}
                                                    min={getContactMask(field.apiAlias)?.length}
                                                />
                                            </div>);
                                    case 'texto':
                                        if (field.apiAlias?.toLowerCase().includes('cpf'))
                                            return (
                                                <div className="control">
                                                    <label htmlFor={String(field.apiAlias)}>
                                                        {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                    </label>
                                                    <Input
                                                        register={register}
                                                        errors={errors}
                                                        mask="999.999.999-99"
                                                        type="text"
                                                        placeholder={field.label}
                                                        name={String(field.columnId)}
                                                        defaultValue={defaultCpf}
                                                        errorMessage={`${field.label} obrigatório`}
                                                        required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                        disabled={true}
                                                        key={field.columnId}
                                                    />
                                                </div>
                                            )
                                        else if (field.apiAlias?.toLowerCase() === 'beneficiario_endereco_cidade')
                                            return (
                                                <div className="control">
                                                    <label htmlFor={String(field.apiAlias)}>
                                                        {renderRequiredLabel(`${field.label} / Estado`, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                    </label>
                                                    <Input
                                                        register={register}
                                                        errors={errors}
                                                        type="text"
                                                        placeholder={field.label}
                                                        name={String(field.columnId)}
                                                        defaultValue={beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value || ''}
                                                        errorMessage={`${field.label} obrigatório`}
                                                        disabled
                                                        required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                        key={field.columnId}
                                                    />
                                                </div>
                                            )
                                        else if (field.apiAlias?.toLowerCase() === 'beneficiario_endereco_bairro')
                                            return (
                                                <div className="control">
                                                    <label htmlFor={String(field.apiAlias)}>
                                                        {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                    </label>
                                                    <Input
                                                        register={register}
                                                        errors={errors}
                                                        type="text"
                                                        placeholder={field.label}
                                                        name={String(field.columnId)}
                                                        defaultValue={beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value || ''}
                                                        errorMessage={`${field.label} obrigatório`}
                                                        value={(beneficiary?.filter(f => f.columnId === field.columnId
                                                        )[0]?.value) ? `${beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value
                                                        }` :
                                                            (address?.neighborhood ? `${address?.neighborhood}` : '')}
                                                        min={1}
                                                        required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                        key={field.columnId}
                                                    />
                                                </div>
                                            )
                                        else if (field.apiAlias?.toLowerCase() === 'beneficiario_endereco')
                                            return (
                                                <div className="control">
                                                    <label htmlFor={String(field.apiAlias)}>
                                                        {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                    </label>
                                                    <Input
                                                        register={register}
                                                        errors={errors}
                                                        type="text"
                                                        placeholder={field.label}
                                                        name={String(field.columnId)}
                                                        defaultValue={beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value || ''}
                                                        errorMessage={`${field.label} obrigatório`}
                                                        value={(beneficiary?.filter(f => f.columnId === field.columnId
                                                        )[0]?.value) ? `${beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value}` :
                                                            (address?.addressLine ? `${address?.addressLine}` : '')}
                                                        min={1}
                                                        required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                        key={field.columnId}
                                                    />
                                                </div>
                                            )

                                        return (
                                            <div className="control">
                                                <label htmlFor={String(field.apiAlias)}>
                                                    {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                </label>
                                                <Input
                                                    register={register}
                                                    errors={errors}
                                                    type="text"
                                                    placeholder={field.label}
                                                    name={String(field.columnId)}
                                                    defaultValue={beneficiary?.filter(f => f.columnId === field.columnId)[0]?.value || ''}
                                                    errorMessage={`${field.label} obrigatório`}
                                                    min={1}
                                                    required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                    key={field.columnId}
                                                />
                                            </div>
                                        )
                                    case 'email':
                                        return (
                                            <div className="control">
                                                <label htmlFor={String(field.apiAlias)}>
                                                    {renderRequiredLabel(field.label, field.isRequiredOnCreate || field.isRequiredOnUpdate)}
                                                </label>
                                                <Input
                                                    register={register}
                                                    errors={errors}
                                                    type="email"
                                                    placeholder={field.label}
                                                    name={String(field.columnId)}
                                                    defaultValue={beneficiary?.find(f => f.columnId === field.columnId)?.value ?? beneficiaryInfo?.email}
                                                    errorMessage={`${field.label} obrigatório`}
                                                    patt={EMAIL_PATTERN('Email')}
                                                    min={1}
                                                    required={field.isRequiredOnCreate || field.isRequiredOnUpdate}
                                                    key={field.columnId}
                                                />
                                            </div>
                                        )
                                    default:
                                        break;
                                }

                            }
                            return null;
                        })
                    }
                    {
                        (isMinor || questionResponsibleDocument) && (
                            <div className="full-width">
                                <AlertInfo className="minorAlert" variant={"warning"}>
                                    <div className="control">
                                        <IoIosInformationCircleOutline size={35} color="#F5AF45" fill="#F5AF45" />

                                        <p>
                                            <strong>Identificamos que o beneficiário possui menos de 18 anos de idade</strong>
                                            <br />
                                            Para prosseguir com o cadastro, será necessário informar os dados do responsável legal.
                                        </p>
                                    </div>
                                </AlertInfo>
                            </div>
                        )
                    }
                    { // Algumas questões do quiz deve ser exibida no formulario de dados pessoais
                        configuration.quiz?.filter(f => f.questions?.map(
                            question => question.questionAlias.toLowerCase() === 'question_responsible_document'
                                || question.questionAlias.toLowerCase() === 'question_responsible_name'
                                || question.questionAlias.toLowerCase() === 'question_responsible_birth_date'
                                || question.questionAlias.toLowerCase() === 'question_responsible_degree_of_kinship'
                                || question.questionAlias.toLowerCase() === 'question_responsible_acceptance'
                        ))[0]?.questions?.map(question => {

                            if (question.questionAlias.toLowerCase() === 'question_responsible_document') {

                                if ((question.isRequired || isMinor || questionResponsibleDocument)) {
                                    return (
                                        <div className="control">
                                            <label htmlFor={String(question.id)}>
                                                {renderRequiredLabel(question.title, question.isRequired || isMinor)}
                                            </label>
                                            <Input
                                                register={register}
                                                errors={errors}
                                                type="text"
                                                key={question.questionAlias.toLowerCase()}
                                                name={String(question.questionAlias.toLowerCase())}
                                                defaultValue={questionResponsibleDocument}
                                                placeholder={question.title}
                                                errorMessage={`Beneficiario menor de idade, obrigatório o CPF do responsável`}
                                                min={1}
                                                required={question.isRequired || isMinor}
                                                mask="999.999.999-99"
                                            />
                                        </div>
                                    )
                                }
                            }

                            if (question.questionAlias.toLowerCase() === 'question_responsible_name') {

                                if ((question.isRequired || isMinor || questionResponsibleName)) {
                                    return (
                                        <div className="control">
                                            <label htmlFor={String(question.id)}>
                                                {renderRequiredLabel(question.title, question.isRequired || isMinor)}
                                            </label>
                                            <Input
                                                register={register}
                                                errors={errors}
                                                type="text"
                                                key={question.questionAlias.toLowerCase()}
                                                name={String(question.questionAlias.toLowerCase())}
                                                defaultValue={questionResponsibleName}
                                                placeholder={question.title}
                                                maxLength={question.maximumAnswerLength}
                                                errorMessage={`Beneficiario menor de idade, obrigatório o nome do responsável`}
                                                min={1}
                                                required={question.isRequired || isMinor}
                                                patt={ALPHATEXT_PATTERN(question.title)}
                                            />
                                        </div>
                                    )
                                }
                            }

                            if (question.questionAlias.toLowerCase() === 'question_responsible_birth_date') {
                                if ((isMinor || questionResponsibleBirthDate)) {
                                    return (
                                        <div className="control">
                                            <label htmlFor={String(question.id)}>
                                                {renderRequiredLabel(question.title, question.isRequired || isMinor)}
                                            </label>
                                            <Input
                                                register={register}
                                                errors={errors}
                                                type="date"
                                                key={question.questionAlias.toLowerCase()}
                                                name={String(question.questionAlias.toLowerCase())}
                                                placeholder={question.title}
                                                defaultValue={formatDateYYYYMMDD(questionResponsibleBirthDate)}
                                                errorMessage="Beneficiario menor de idade, obrigatório data de nascimento do responsável"
                                                required={question.isRequired || isMinor}
                                                max={new Intl.DateTimeFormat('fr-ca').format(new Date())}
                                                min={new Intl.DateTimeFormat('fr-ca').format(new Date(1900, 0, 1))}
                                            />
                                        </div>
                                    )
                                }
                            }

                            if (question.questionAlias.toLowerCase() === 'question_responsible_degree_of_kinship') {
                                if ((isMinor || questionResponsibleDegreeKinship)) {
                                    return (
                                        <div className="control">
                                            <label htmlFor={String(question.id)}>
                                                {renderRequiredLabel(question.title, question.isRequired || isMinor)}
                                            </label>
                                            <select
                                                key={question.questionAlias.toLowerCase()}
                                                name={String(question.questionAlias.toLowerCase())}
                                                defaultValue={questionResponsibleDegreeKinship}
                                                required={question.isRequired || isMinor}
                                                ref={register({
                                                    required: {
                                                        value: question.isRequired || isMinor,
                                                        message: `${question.title} obrigatório`
                                                    }
                                                })}
                                            >
                                                {question.allowedValues?.map(allowedValue => (
                                                    <option key={allowedValue.value} value={allowedValue.value}>{allowedValue.label}</option>
                                                ))}
                                            </select>
                                            {errors[String(question.questionAlias.toLowerCase())] && <span className="input-error-message">{errors[String(question.questionAlias.toLowerCase())].message}</span>}
                                        </div>
                                    )
                                }
                            }

                            if (question.questionAlias.toLowerCase() === 'question_responsible_acceptance') {
                                if ((isMinor || questionResponsibleAcceptance)) {
                                    return (
                                        <div className="control">
                                            <label htmlFor={String(question.questionAlias.toLowerCase())}>
                                                {renderRequiredLabel(question.title, question.isRequired || isMinor)}
                                            </label>

                                            <input
                                                id={String(question.questionAlias.toLowerCase())}
                                                type="checkbox"
                                                style={{ width: "5%", marginLeft: "1%" }}
                                                key={question.questionAlias.toLowerCase()}
                                                name={String(question.questionAlias.toLowerCase())}
                                                placeholder={question.title}
                                                onChange={(e) => { checkQuestionResponsible(e.currentTarget.checked) }}
                                                checked={responsibleAcceptance}
                                                required={question.isRequired || isMinor}
                                                ref={register({
                                                    required: {
                                                        value: question.isRequired || isMinor,
                                                        message: question.title + " é obrigatório."
                                                    }
                                                })}
                                            />
                                            {errors[String(question.questionAlias.toLowerCase())] && <span className="input-error-message">{errors[String(question.questionAlias.toLowerCase())].message}</span>}
                                        </div>
                                    )
                                }
                            }

                            return null;
                        })
                    }

                </div>
                {!isMinor && !beneficiaryHasCaregiver && <div style={{ marginTop: '1rem', marginLeft: '-10px' }}>
                    {
                        termBeneficiary?.questions
                            ?.filter(x => !beneficiaryHiddenTermQuestions.includes(x.questionAlias.toLowerCase()))
                            .sort(termBeneficiaryQuestionOrdering)
                            .map(renderTermBeneficiaryQuestion)
                    }
                </div>}
                {plainHasCaregiver &&
                    <div style={{ textAlign: "center" }} className="control">
                        <label htmlFor={'possuio_cuidador'}>
                            <span>O</span> Beneficiario <span>possui</span> Cuidador
                        </label>
                        <div className="radioBoxes">
                            <div className="radio-container">
                                <input
                                    id={'possuio_cuidador_Sim'}
                                    type="checkbox"
                                    key={'possuio_cuidador_Sim'}
                                    name={'possuio_cuidador_Sim'}
                                    onChange={(e) => { setBeneficiaryHasCaregiver(e.currentTarget.checked) }}
                                    checked={beneficiaryHasCaregiver}
                                />
                                <label htmlFor="possuio_cuidador_Sim" className="checkboxLabel">Sim</label>
                            </div>

                            <div className="radio-container">
                                <input
                                    id={'possuio_cuidador_Nao'}
                                    type="checkbox"
                                    key={'possuio_cuidador_Nao'}
                                    name={'possuio_cuidador_Nao'}
                                    onChange={(e) => { setBeneficiaryHasCaregiver(false) }}
                                    checked={!beneficiaryHasCaregiver}
                                />
                                <label htmlFor="possuio_cuidador_Nao" className="checkboxLabel">Não</label>
                            </div>
                        </div>
                    </div>
                }
                {beneficiaryHasCaregiver && plainHasCaregiver && <div>
                    {/* <hr /> */}
                    <h1 style={{ textAlign: "center", marginTop: "3rem", marginBottom: "4rem" }}>Dados do Cuidador</h1>
                    {/* <hr /> */}

                    <div style={{ textAlign: "center" }} className="control">
                        <label htmlFor={'mesmo_endereco'}>
                            <span>O</span> Cuidador <span>e o</span> Beneficiário <span>possuem o mesmo endereço?</span>
                        </label>
                        <div className="radioBoxes">
                            <div className="radio-container">
                                <input
                                    id={'mesmo_endereco_Sim'}
                                    type="checkbox"
                                    key={'mesmo_endereco_Sim'}
                                    name={'mesmo_endereco_Sim'}
                                    onChange={() => { handleSameAddress(); }}
                                    checked={sameAddress}
                                />
                                <label htmlFor="mesmo_endereco_Sim" className="checkboxLabel">Sim</label>
                            </div>

                            <div className="radio-container">
                                <input
                                    id={'mesmo_endereco_Nao'}
                                    type="checkbox"
                                    key={'mesmo_endereco_Nao'}
                                    name={'mesmo_endereco_Nao'}
                                    onChange={(e) => { setSameAddress(false) }}
                                    checked={!sameAddress}
                                />
                                <label htmlFor="mesmo_endereco_Nao" className="checkboxLabel">Não</label>
                            </div>
                        </div>
                    </div>

                    <div className="form-fields">
                        {
                            fieldsCaregiver.filter(x => x.questionType.toLocaleLowerCase() !== "checkbox"
                                && !caregiverApiAliasHidden.includes(x.questionAlias.toLowerCase())
                            ).map(x => {

                                let configRegister = {
                                    required: {
                                        value: beneficiaryHasCaregiver,
                                        message: `${x.title} de preenchimento obrigatório`
                                    }
                                }

                                let defaultValue = lastCaregivenData?.quizz?.find((df: { questionAlias: string; }) => df.questionAlias.toLocaleLowerCase() == x.questionAlias.toLocaleLowerCase()).value

                                const contactNumbers = {
                                    "question_caregiver_phone": `${lastCaregivenData?.quizz?.find((df: { questionAlias: string; }) => df.questionAlias.toLocaleLowerCase() == 'question_caregiver_areacodephone').value || ''}${defaultValue || ''}`,
                                    "question_caregiver_cellphone": `${lastCaregivenData?.quizz?.find((df: { questionAlias: string; }) => df.questionAlias.toLocaleLowerCase() == "question_caregiver_areacodecellphone").value || ''}${defaultValue || ''}`,
                                } as any

                                defaultValue = fieldsCaregiverData[x.questionAlias.toLocaleLowerCase()] || contactNumbers[x.questionAlias.toLocaleLowerCase()] || defaultValue

                                const onBlur = (e: any) => {
                                    setFieldsCaregiverData({ ...fieldsCaregiverData, [x.questionAlias.toLocaleLowerCase()]: e.target.value })
                                    if(x.questionAlias.toLocaleLowerCase() ===  "question_caregiver_zipcode"){
                                        
                                        handleGetCaregiverAddress(e.target.value)
                                    }
                                }
                                
                                return (
                                    HTMLElement(x, register(configRegister), defaultValue, errors, register, null, (addressCaregiver.includes(x.questionAlias.toLowerCase()) && sameAddress), beneficiaryHasCaregiver && !fieldsCaregiverNotRequired.includes(x.questionAlias.toLowerCase()), onBlur)
                                )
                            })
                        }
                    </div>
                    <div style={{ marginTop: '1rem', marginLeft: '-10px' }}>
                        {
                            checkBoxesCaregiven.filter(x => !checkBoxesCaregiverHidden.includes(x.questionAlias.toLowerCase())).map((x) => (HTMLElement(x, register({
                                required: {
                                    value: false,
                                    message: `${x.title} de preenchimento obrigatório`
                                }
                            }), lastCaregivenData?.quizz?.find((df: { questionAlias: string; }) => df.questionAlias.toLocaleLowerCase() == x.questionAlias.toLocaleLowerCase())?.value || '', errors, register))
                            )
                        }
                    </div>

                </div>
                }



                <ContainerOptionsRadio>

                    <ContainerReceiveAccess>

                        {!haveRegistration && !!receiveAccess &&
                            <>
                                <label htmlFor="questionReceiveAccess">
                                    {renderRequiredLabel(receiveAccess?.title || '', true)}
                                </label>
                                <div className="control">
                                    {
                                        receiveAccess?.allowedValues?.map(allowed => {
                                            return (
                                                <>
                                                    <label htmlFor={String(allowed.id)}>
                                                        {allowed.label}
                                                    </label>
                                                    <input
                                                        type="radio"
                                                        name="questionReceiveAccess"
                                                        id={String(allowed.id)}
                                                        value={allowed.value}
                                                        required
                                                        ref={register({
                                                            required: {
                                                                value: true,
                                                                message: 'Selecione uma opção de acesso'
                                                            }
                                                        })}
                                                        key={allowed.id}
                                                    />
                                                </>
                                            )
                                        })
                                    }
                                </div>
                                {errors['questionReceiveAccess'] && <span className="input-error-message">{errors['questionReceiveAccess'].message}</span>}
                            </>
                        }
                    </ContainerReceiveAccess>
                </ContainerOptionsRadio>

                <ContainerContactTypes>
                    {(questionAcceptContactTypesValues?.length > 0) &&
                        <>
                            <label>Autorizo contato do Programa União com Você por:</label>
                            <br />
                            <div className="control">
                                {
                                    questionAcceptContactTypesValues?.map((allowed, i) => {
                                        return (
                                            <>
                                                <input
                                                    type="checkbox"
                                                    name={String(allowed.id)}
                                                    id={String(allowed.id)}
                                                    disabled={allowed.title == "SMS"}
                                                    defaultChecked={eval("contact" + i)}
                                                    onChange={(e) => { setCheckedContactType(i, e.currentTarget.checked) }}
                                                    required={allowed.isRequired}
                                                    ref={register({
                                                        required: {
                                                            value: allowed.isRequired,
                                                            message: `${allowed.title} é obrigatório`
                                                        }
                                                    })}
                                                    key={String(allowed.id)}
                                                />
                                                <label htmlFor={String(allowed.id)}>
                                                    {allowed.title}
                                                </label>
                                            </>
                                        )
                                    })
                                }
                            </div>
                        </>
                    }
                </ContainerContactTypes>


                <Navigation>
                    <Button type="button" className="secondary-button" isActive={false} disabled={isActiveLoader} onClick={goBackSearch}>
                        Voltar
                    </Button>

                    <Button type="submit" isActive={isActiveLoader} disabled={isSubmitButtonDisabled}>

                        {(hasQuizzes && otherIssuesBeyondTheTerm) ? 'Avançar' : 'Salvar'}
                    </Button>

                </Navigation>
            </Form>
        </Container>
    )
}
